import { ListCodesItemSchema } from '@src/entities/Code/api/requests/queries/ListCodes/includes/schema';
import { z } from 'zod';

export const ListEventTypesItemSchema = ListCodesItemSchema.extend({
  categoryCode: z.literal('EventType'),
});

export const ListEventTypesSchema = z.array(ListEventTypesItemSchema);
